import {Unauthorized} from "api-client";
import {AuthTokenExpired, RouteDictionary} from "utils";
import {useNavigateByName} from "./useNavigateByName";
import {createAuthTokenManager} from "../di";
import {useAppDispatch} from "./store";
import {clear} from "../store/profile";
import {useNotifier} from "./useNotifier";
import {useCallback} from "react";
import axios from "axios";

export const useErrorCallback = () => {
  const navigate = useNavigateByName();
  const dispatch = useAppDispatch();
  const notifier = useNotifier();
  const tokenManager = createAuthTokenManager();
  return useCallback(async (error: Error) => {
    if (axios.isAxiosError(error)) {
      const status = error.response?.status;
      const data = error.response?.data;

      if (data?.name === "ConflictError" || status === 409) {
        notifier.createError(data.message || "Возник конфликт");
        return;
      }

      if (status === 422) {
        notifier.createError(data?.message || "Необрабатываемый запрос");
        return;
      }

      if (status === 429) {
        notifier.createError(data?.message || "Слишком много запросов. Попробуйте позже");
        return;
      }
    }
    if (error instanceof Unauthorized || error instanceof AuthTokenExpired) {
      //TODO: make redirectTo store
      tokenManager.remove();
      await dispatch(clear());
      await navigate(RouteDictionary.ENTER);
      return;
    }

    notifier.createError("Что-то пошло не так");
  }, [navigate, dispatch, notifier, tokenManager]);
};